/** Access to the puter.js global, with a friendly failure mode. */

export function hasPuter() {
  return typeof window !== 'undefined' && !!window.puter;
}

export function getPuter() {
  if (!hasPuter()) {
    throw new Error(
      'JTQ Meet couldn’t load. Check your connection and reload the page.'
    );
  }
  return window.puter;
}
